// EngagementNotes.jsx

// Components
import TextEditor from '@/components/data/common/text/TextEditor';

// Services
import { updateEngagementNotes, deleteEngagementNotes } from '@/services/schedulingService';

const EngagementNotes = ({ engagementID, engagementNotes }) => {
  async function deleteNotes() {
    await deleteEngagementNotes(engagementID);
  }

  async function updateNotes(notes) {
    await updateEngagementNotes(engagementID, notes);
  }

  return <TextEditor value={engagementNotes} updateText={updateNotes} deleteText={deleteNotes}></TextEditor>;
};

export default EngagementNotes;
